import { WorkInHeader } from "../../../../src/components/work-in/header";
import { WorkTutorial } from "../../../../src/components/work/tutorial";
import { WorkCommunity } from "../../../../src/components/work/community";
import { WorkJobTypes } from "../../../../src/components/work/job-types";
import { WorkReviews } from "../../../../src/components/work/reviews";
import { WorkStoreWidget } from "../../../../src/components/work/store-widget";
import { CommonFAQ } from "../../../../src/components/common/faq";
import { Footer } from "../../../../src/components/common/footer";
import * as React from 'react';
export default {
  WorkInHeader,
  WorkTutorial,
  WorkCommunity,
  WorkJobTypes,
  WorkReviews,
  WorkStoreWidget,
  CommonFAQ,
  Footer,
  React
};